import { render, staticRenderFns } from "./mailbox-settings-office-hours-day.vue?vue&type=template&id=09197eea&scoped=true&"
import script from "./mailbox-settings-office-hours-day.vue?vue&type=script&lang=ts&"
export * from "./mailbox-settings-office-hours-day.vue?vue&type=script&lang=ts&"
import style0 from "./mailbox-settings-office-hours-day.vue?vue&type=style&index=0&id=09197eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09197eea",
  null
  
)

export default component.exports